export default function () {
  window.filterCards = function (section) {
      const cardContainer = section.querySelectorAll('.cards')[0];
      const filterInput = section.querySelectorAll('input')[0];
      const cards = section.querySelectorAll('.card');
      const searchCategory = cardContainer.getAttribute('data-search-category');
      const searchType = cardContainer.getAttribute('data-search-type');

      cards?.forEach(el => {
          const categories = el.getAttribute('data-categories')?.split(', ');
          const types = el.getAttribute('data-types')?.split(', ');
          if (!categories || !types) {
            console.warn(`Missing data-categories or data-types attribute on card element`);
          }
          el.classList.add('hidden');
          if ((searchCategory === 'all' || categories.includes(searchCategory)) && (searchType === 'all' || types.includes(searchType))) {
            if (filterInput) {
              const content = el.querySelectorAll('h6, p');
              content.forEach(element => {
                if (element.innerHTML.toLowerCase().includes(filterInput.value.toLowerCase())) {
                  el.classList.remove('hidden');
                }
              });
            } else {
              el.classList.remove('hidden');
            }
          }
      });
  };

  window.setFilterType = function (section, targetType) {
    section = document.querySelectorAll('#' + section)[0];
    const cardContainer = section.querySelectorAll('.cards')[0];
    cardContainer.setAttribute('data-search-type', targetType);

    window.filterCards(section);
  };

  const filterButtons = document.querySelectorAll('[data-target-category], [data-target-type]');
  if (filterButtons !== null) {
    filterButtons.forEach(el => {
      el.addEventListener('click', function (event) {
        event.preventDefault();
        const targetCategory = this.getAttribute('data-target-category');
        const targetType = this.getAttribute('data-target-type');
        const section = this.closest('section');
        const cardContainer = section.querySelectorAll('.cards')[0];

        if (targetCategory !== null) {
          this.parentNode.querySelectorAll('[data-target-category]').forEach(el => {
            el.classList.remove('active');
          });
          this.classList.add('active');
          cardContainer.setAttribute('data-search-category', targetCategory);
        } else if (targetType !== null) {
          this.parentNode.querySelectorAll('[data-target-type]').forEach(el => {
            el.classList.remove('active');
          });
          this.classList.add('active');
          cardContainer.setAttribute('data-search-type', targetType);
        }

        window.filterCards(section);
      });
    });
  }

  const filterInput = document.querySelectorAll('.webex-cards input');
  if (filterInput !== null) {
    filterInput.forEach(el => {
      el.addEventListener('input', function (event) {
        event.preventDefault();
        const section = this.closest('section');

        window.filterCards(section);
      });
    });
  }
}
